import { useContext } from 'react'

import { userContext } from 'global/context/sub-contexts/userContext'

/*
Usage:
    const { authRequiredAction } = useAuthRequired();

    const handleButtonClick = () => {
        authRequiredAction(() => {
            // perform action that users can do
        });
    };

    ...
    <button onClick={handleButtonClick} >Redeem Now</button>

---

One could imagine another version of authRequiredAction that takes in 2 methods, 
one for success, one for failure  

*/
export const useAuthRequired = (isGuestAllowed = false) => {
  const user_context = useContext(userContext)
  const { askToLogin } = user_context

  const profile = user_context.getProfile()

  const isLoggedIn = (profile.guest && isGuestAllowed) || !profile.guest

  const authRequiredAction = action => {
    // console.log(`authRequiredAction`, profile)
    if (isLoggedIn) {
      typeof action === 'function' && action()
    } else {
      // console.log("show modal")
      askToLogin()
    }
  }

  return {
    authRequiredAction,
    isLoggedIn: isLoggedIn,
  }
}
